// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-ui-PeopleSwitcher-styles__root"};